/** 
  The objectToParams function, get object returns string of params
  @params 
    params: Object of params
  @return constructed string of params
*/
export default function objectToParams(params = {}) {
  const paramsString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return paramsString ? "?".concat(paramsString) : "";
}
/** 
  The paramsToObject function, get string of params returns object
  @params 
    searchQuery: string of params
  @return constructed object of params
*/
export function paramsToObject(searchQuery = "") {
  const paramsString = searchQuery.split("?").pop();
  if (!paramsString) return {};
  const arrayOfParams = paramsString.split("&").map(param => param.split("="));
  const params = Object.fromEntries(arrayOfParams);
  return params;
}
